/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
/* eslint-disable max-statements */
import { useKeystoneSession } from '../../auth/use-keystone-session';
import { CountertopSkuAssetData, CountertopSkuData } from '@rta/rta-blueprint-library';
import { useEffect, useState } from 'react';

import { NavType } from '@state';
import { getProducts } from '@external';

// Singleton state outside the component
let accessoryItemDataCache: CountertopSkuAssetData | null = null;
let loadPromise: Promise<CountertopSkuAssetData> | null = null;

export const useLoadCountertopSkuData = (): CountertopSkuAssetData | null => {
	const { getToken, status } = useKeystoneSession();
	const isAuthenticated = status === 'ready';

	const [accessoriesItemData, setComponentItemData] = useState<CountertopSkuAssetData | null>(accessoryItemDataCache);

	useEffect(() => {
		if (!isAuthenticated) return;

		if (accessoryItemDataCache) {
			return;
		}

		if (loadPromise) {
			loadPromise.then(setComponentItemData);
			return;
		}

		loadPromise = (async () => {
			try {
				const accessoriesData = await getProducts<Record<string, CountertopSkuData>>({
					fileName: 'countertop-skus-item-data',
					getToken,
					setError: (error) => console.error('Error loading accessories:', error)
				});

				accessoryItemDataCache = CountertopSkuAssetData.getInstance({
					callback: () => (accessoriesData || {})
				});

				console.log('Loaded accessories:', accessoryItemDataCache, accessoriesData);
				return accessoryItemDataCache;
			} catch (error) {
				console.error('Failed to load accessories data:', error);
				accessoryItemDataCache = CountertopSkuAssetData.getInstance({
					callback: () => ({})
				});
				return accessoryItemDataCache;
			}
		})();

		loadPromise.then(setComponentItemData);
	}, [isAuthenticated]);

	return accessoriesItemData;
};
